import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { FieldHelperText } from "../field-helper-text/field-helper-text.js";
import { Translate } from "../translate/translate.js";
import { TextField, Label } from "./text-input.styles.js";
import "@mui/material";
import "../../utils/yup/main.js";
import "yup";
import "../../utils/fields/personalInformation.js";
import "../../../../../type/Appointment.js";
import "../masked-date-input/masked-date-input.js";
import "react-text-mask";
import "../../utils/entities/Form.js";
import "../../../ana-toolbox/ana-toolbox.js";
import "../../../../../constants/date/date.js";
import "date-fns/fp/format";
import "date-fns/isValid";
import "date-fns/parse";
import "date-fns";
import "../../utils/helpers/toBoolean.js";
import "../../utils/helpers/createFields.js";
import "../../utils/helpers/resetFields.js";
import "../../utils/yup/yup.js";
import "../../../../../utils/pipe.js";
import "date-fns/fp";
import "libphonenumber-js/max";
import "libphonenumber-js/mobile";
import "../../utils/helpers/predicates.js";
import "../../utils/yup/emailValidation.js";
import "../../utils/fields/contactDetails.js";
import "../../utils/helpers/featureFlags.js";
import "../../utils/helpers/getAgeFromBirthday.js";
import "../../utils/yup/buildValidationSchema.js";
import "../../utils/fields/miscellaneous.js";
import "../../utils/fields/insurance.js";
import "../../utils/fields/allergiesAndMedications.js";
import "../../../../../type/Disease.js";
import "../../utils/config/medicaments.js";
import "../../utils/fields/wishesAndExpectations.js";
import "../../utils/fields/consents.js";
import "../../utils/fields/profileInterest.js";
const TextInput = memo(
  ({
    className,
    value,
    required = false,
    label,
    name,
    InputLabelProps,
    placeholder,
    inputComponent,
    helperText,
    error,
    endAdornment,
    ...props
  }) => {
    const { t } = useTranslation();
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(
        TextField,
        {
          value,
          name,
          className,
          label: /* @__PURE__ */ jsx(Label, { required, children: /* @__PURE__ */ jsx(Translate, { children: label }) }),
          InputProps: {
            inputComponent,
            endAdornment
          },
          InputLabelProps: {
            id: `${name}-label`,
            htmlFor: name,
            ...InputLabelProps
          },
          FormHelperTextProps: {
            id: `${name}-helperText`
          },
          inputProps: {
            "data-placeholder-translation-key": placeholder,
            "aria-labelledby": `${name}-label`,
            id: name
          },
          error: Boolean(error),
          variant: "outlined",
          placeholder: placeholder ? t(placeholder) || "" : t(`${label}_placeholder`, { defaultValue: "", postProcess: [] }) || "",
          fullWidth: true,
          ...props
        }
      ),
      /* @__PURE__ */ jsx(FieldHelperText, { helperText, error, name })
    ] });
  }
);
export {
  TextInput
};
